import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";

import {
    TouchableOpacity,
    View
} from 'react-native';

import AppTheme from "../../../shared/utils/Theme";

import "./AudioPlayer.css"

import SVGView from "../../../shared/utils/SvgView";
import { default as IcPlay } from "../../../shared/assets/svg/icons/solid/play.svg";
import { default as IcPause } from "../../../shared/assets/svg/icons/solid/pause.svg";

import CircularSlider from '@fseehawer/react-circular-slider';

const AudioPlayer = forwardRef((props: any, ref) => {

    const audioPlayerRef = useRef(null);

    const [isPlaying, setIsPlaying] = useState<boolean>(false);
    const [songDuration, setSongDuration] = useState<number>(0);
    const [songIndex, setSongIndex] = useState(0);
    const { urls, image, percentageForCompletion = 75, gamification = true, displayView = true, onPlayerEnd, onChangeUrl } = props;
    const [position, setPosition] = useState(-1);


    const stopThePlayer = () => {
        /*
        audioPlayerInstance.audioElement.pause();
        audioPlayerInstance.audioElement.currentTime = 0;
        audioPlayerInstance.audioElement.remove();
        audioPlayerInstance.audioElement.oncanplay = () => { };
        */
    }

    useImperativeHandle(ref, () => ({
        onStopRequest: () => {
            stopThePlayer();
        }
    }));

    useEffect(() => {
        if (props.stopRequest === true) {
            stopThePlayer();
        }
    }, [props.stopRequest]);

    const onAudioPlayerEnd = () => {
        if (songIndex + 1 < urls.length) {
            setSongIndex(songIndex + 1);
        } else {
            if (onPlayerEnd !== undefined) {
                onPlayerEnd();
            }
        }
    };

    const togglePlayPause = () => {
        if (isPlaying === true) {
            audioPlayerRef.current.pause();
        } else {
            audioPlayerRef.current.play();
        }
        setIsPlaying(!isPlaying);
    }

    useEffect(() => {
        if (songIndex > -1) {
            if (urls[songIndex].includes("https://") === true) {
                // On va mettre en cache le fichier audio

            }
        }
    }, [songIndex]);

    const appTheme: AppTheme = new AppTheme();
    let audioPlayerSize: number = 100;
    if (props.size !== undefined) {
        audioPlayerSize = props.size;
    };

    if (displayView === false) {
        return <View />;
    }

    const viewSize = audioPlayerSize;
    const playerIconSize = audioPlayerSize * 0.2;
    const playerIconContainerSize = audioPlayerSize * 0.6;

    const onSeekRequest = (amount: number) => {
        if ((amount !== Math.ceil(position)) && (amount !== Math.floor(position)) && (amount > Math.floor(position) + 10)) {
            audioPlayerRef.current.pause();
            let seekToValue: number = (amount / 360) * songDuration;
            console.log({seekToValue, songDuration});
            if (seekToValue < songDuration) {
                audioPlayerRef.current.currentTime = seekToValue;
                console.log(audioPlayerRef.current.currentTime);
            }
            audioPlayerRef.current.play();
        }
    };

    const renderCircularSlider = () => {
        if ((songDuration < 30) || (position === -1)) {
            return <View />
        }
        return <View style={{ position: "absolute" }}>
            <CircularSlider
                width={viewSize}
                initialValue={0}
                label="savings"
                labelColor="#ffffff"
                knobColor={props.color}
                progressColorFrom={props.color}
                progressColorTo={props.color}
                progressSize={12}
                trackColor="#eeeeee"
                hideLabelValue={true}
                children={false}
                trackSize={16}
                min={0}
                max={360}
                dataIndex={position}
                onChange={onSeekRequest}
            />
        </View>
    }

    const isVariableDefined = (variable: any) => {
        if ((variable !== undefined) && (variable !== null)) {
            return true;
        }
        return false;
    }

    const onTimeUpdate = (time) => {
        if ((isVariableDefined(time) === true) && ((isVariableDefined(time.nativeEvent) === true) && (isVariableDefined(time.nativeEvent.target) === true) && (isVariableDefined(time.nativeEvent.target.currentTime === true)))) {
            if (songDuration > 0) {
                const updatedPosition: number = time.nativeEvent.target.currentTime * 360 / songDuration;
                setPosition(updatedPosition);
            }
        }
    }

    const onDurationChange = (duration) => {
        if ((isVariableDefined(duration) === true) && ((isVariableDefined(duration.nativeEvent) === true) && (isVariableDefined(duration.nativeEvent.target) === true) && (isVariableDefined(duration.nativeEvent.target.duration === true)))) {
            console.log(duration);
            setSongDuration(duration.nativeEvent.target.duration);
        }
    }

    const onCanPlayThrough = (e) => {
        console.log(e);
    }

    const getHTMLAudioPlayer = () => {
        return <audio
            controls={false}
            onDurationChange={onDurationChange}
            onPause={() => setIsPlaying(false)}
            onPlay={() => setIsPlaying(true)}
            ref={audioPlayerRef}
            autoPlay={true}
            preload="auto"
            id="myAudio"
            onEnded={onAudioPlayerEnd}
            onTimeUpdate={onTimeUpdate}
            src={urls[songIndex]}
        />
    }

    return (<View style={{ width: viewSize, height: viewSize, display: "flex", justifyContent: "center", alignItems: "center" }} >
        {renderCircularSlider()}
        {getHTMLAudioPlayer()}
        <TouchableOpacity onPress={togglePlayPause} style={{ borderRadius: playerIconContainerSize / 2, width: playerIconContainerSize, height: playerIconContainerSize, backgroundColor: props.color, display: "flex", justifyContent: "center", alignItems: "center" }}>
            <SVGView Component={isPlaying === true ? IcPause : IcPlay} width={playerIconSize} height={playerIconSize} color={appTheme.white} />
        </TouchableOpacity>
    </View>)
});

export default AudioPlayer;